import logNotificationUpdateForDiagnosticsAsync from './utils/logNotificationUpdateForDiagnosticsAsync';
import { LazyImport, LazyModule } from 'owa-bundling';

export { CalendarNotificationUpdateLog } from './store/schema/CalendarNotificationDiagnosticsStore';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "CalendarNotificationDiagnostics", webpackPrefetch: true */ './lazyIndex')
);

export const lazyLogNotificationUpdateForDiagnostics = new LazyImport(
    lazyModule,
    m => m.logNotificationUpdateForDiagnostics
);

export { logNotificationUpdateForDiagnosticsAsync };
